/**
 * @version 2.0alpha
 * @author Kelnik Studios {http://kelnik.ru}
 */

/**
 * Dependencies
 */
// import template from './template/content.twig';
// import Utils from '../../common/scripts/utils';
import Mediator from 'common/scripts/mediator';

/**
 * Variables && constants
 */
// массив get параметров из урла. Будем сравнивать дата таб атрибуты табов из всех экземпляров класса с данными из
// массива, что бы открывать нужные табы при открытии страницы по ссылке
// let urlArray = [];

/**
 * Табы
 * @param {Object} element - обератка всего блока
 * @constructor
 */
class Tabs {
    constructor() {
        this.mediator = new Mediator();
        // нода родителя табов (элементов переключения табов)
        this.tabsParent = {};

        // массив табов (элементов переключения табов)
        this.tabs = [];

        // нода родителя контента табов
        this.contentsParent = {};

        // массив элементов с контентов табов
        this.contents = [];

        // записываем данные таба на котором произошло событие клика
        this.dataTab = {};

        // Класс активного(выбранного) таба
        this.active = 'is-active';

        // Класс задисабленного таба
        this.disabled = 'is-disabled';

        this.objectClass = 'j-tabs-object';
    }

    init(options) {
        this.tabsParent = document.querySelector(options.element) || null;

        // Проверка на наличие табов
        if (!this.tabsParent) {
            console.error('Need target element - ' +
                'https://kelnik.gitbooks.io/kelnik-documentation/front-end/components/tabs.html');

            return;
        }

        // находим все табы и приводим коллекцию нод к массиву. Для работы с forEach в ИЕ.
        this.tabs = Array.from(this.tabsParent.querySelectorAll('.b-tabs__item'));

        this.contentsParent = document.querySelector(`.${this.tabsParent.dataset.content}`);

        // находим все элементы контента и приводим коллекцию нод к массиву. Для работы с forEach в ИЕ.
        this.contents = Array.from(this.contentsParent.querySelectorAll('.b-tabs-content__item'));

        this.bindEvents();
        // this.checkUrlParam();
    }

    /**
     * Вешаем слушатель на табы
     */
    bindEvents() {
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.toggleTab.bind(this));
        });
    }

    /**
     * Переключаем табы
     * @param {event} event - передаем событие
     */
    toggleTab(event) {
        event.preventDefault();
        const tab = event.currentTarget;

        if (tab.classList.contains(this.disabled)) {
            return;
        }

        this.setData(tab);
        this.changeState();
        if (this.tabsParent.classList.contains(this.objectClass)) {
            this._setParentActive(tab);
        }
        // this.stateUrl(tab);
        this.mediator.publish('tabSwitched');
    }

    /**
     * Получаем значения data атрибутов таба
     * @param {node} activeTab - нода таба по которому произошло событие клика
     */
    setData(activeTab) {
        this.dataTab = {
            tab : activeTab,
            id  : activeTab.dataset.tab,
            url : activeTab.getAttribute('href'),
            ajax: activeTab.dataset.ajax
        };
    }

    /**
     * Проверяем есть ли в url'e параметры.
     */
    // checkUrlParam() {
    //     if (window.location.search) {
    //         this.getUrlParams();
    //     }
    // }

    /**
     * Проверяем наличие в href ссылки (жмакнутый таб) наличие строки с адресом.
     * проверяется сам факт наличия более одного символа (в пустой ссылке всегда должен быть #)
     * @returns {boolean} true or false
     */
    isLink() {
        if (!this.dataTab.url) {
            return false;
        }

        const arrSlice = {
            begin: 0,
            end  : -1
        };

        return this.dataTab.url.slice(arrSlice.begin, arrSlice.end);
    }

    /**
     * Проверяем наличие класса is-disabled у жмакнутого таба
     * @returns {boolean} false or true
     */
    isDisableTab() {
        return this.dataTab.tab.classList.contains(this.disabled);
    }

    /**
     * Меняем состояние табов
     */
    changeState() {
        // ничего не делаем если таб неактивен
        if (this.isDisableTab()) {
            return;
        }

        // переходим по ссылке в табе при ее наличии
        if (this.isLink()) {
            location.href = this.dataTab.url;

            return;
        }

        // закружаем контент ajax'ом
        // if (this.dataTab.ajax) {
        //     this.ajaxLoad();
        // }

        // меняем состояние табов
        this.tabs.forEach((element) => {
            if (element.dataset.tab === this.dataTab.id) {
                element.classList.add(this.active);

                return;
            }
            element.classList.remove(this.active);
        });

        // и показываем нужный контент
        this.contents.forEach((element) => {
            if (element.dataset.tabContent === this.dataTab.id) {
                element.classList.add(this.active);

                this.mediator.publish('changeTabs', element);

                return;
            }
            element.classList.remove(this.active);
        });
    }

    _setParentActive() {
        this.tabs.forEach((element) => {
            if (element.dataset.tab === this.dataTab.id) {
                element.parentElement.classList.add(this.active);

                return;
            }
            element.parentElement.classList.remove(this.active);
        });
    }

    /**
     * Сравниваем get параметры из Url'a со значениями data-tab атрибута жмакнутого таба
     * @param {Object} activeTab - таб на котором произошло событие клик
     */
    // забыл JSDOC - что такое activeTav? из названия понятно, но с JSDOC лучше
    // метод очень большой не понятно, что является результатм работы метода
    // по идее раз сравнивает , то должен вернуть true или false
    // stateUrl(activeTab) {
    //     // const tabId = activeTab.dataset.tab;
    //     const tabId = this.dataTab.id;
    //     const tabUrl = activeTab.getAttribute('href');
    //     const getUrl = window.location.search.slice(1);
    //     const getArray = getUrl.split('&');
    //     let congruenceTabUrl = true;
    //
    //     const arrSlice = {
    //         begin: 0,
    //         end  : -1
    //     };
    //
    //     // проверяем, есть ли url в href
    //     if (tabUrl.slice(arrSlice.begin, arrSlice.end)) {
    //         return;
    //     }
    //
    //     // проверяем, есть ли get параметр в url'e и если его еще пока нет, передаем туда значение data-tab атрибута
    //     // жмакнутого таба
    //     if (!getUrl) {
    //         urlArray[urlArray.length] = tabId;
    //         this.changeUrl();
    //
    //         return;
    //     }
    //
    //
    //     for (let i = 0; i < getArray.length; i++) {
    //         if (getArray[i] === tabId) {
    //             i = getArray.length;
    //
    //             return;
    //         }
    //
    //         for (let tabIndex = 0; tabIndex < this.tabs.length; tabIndex++) {
    //             if (getArray[i] === this.tabs[tabIndex].dataset.tab) {
    //                 urlArray[getArray.indexOf(getArray[i])] = tabId;
    //                 tabIndex = this.tabs.length;
    //                 i = getArray.length;
    //                 this.changeUrl();
    //
    //                 return;
    //             }
    //
    //             congruenceTabUrl = false;
    //         }
    //     }
    //
    //     if (!congruenceTabUrl) {
    //         urlArray[urlArray.length] = tabId;
    //         this.changeUrl();
    //     }
    // }

    /**
     * Формируем строку с get параметрами для смены url'a
     */
    // changeUrl() {
    //     const urlString = urlArray.join('&');
    //
    //     window.history.replaceState(`?${urlString}`, null, `?${urlString}`);
    // }

    // /**
    //  * Подгружаем ajax
    //  */
    // ajaxLoad() {
    //     const that = this;
    //     const ajaxUrl = `/tests/${that.dataTab.ajax}`;
    //
    //     Utils.send(null, ajaxUrl,
    //         {
    //             success(req) {
    //                 that.addPageContent(req, that.dataTab.tab);
    //             },
    //             error(err) {
    //                 console.error(`ошибка на сервере: ${err}`);
    //             }
    //         });
    // }
    //
    // /**
    //  * Добавляем контент пришедший с сервера на страницу
    //  * @param {object} data - ответ от сервера при ajax запросе
    //  * @param {node} activeTab - таб по которому произошел клик
    //  */
    // addPageContent(data, activeTab) {
    //     this.contents.forEach((element) => {
    //         if (element.dataset.tabContent === activeTab.dataset.tab) {
    //             element.innerHTML = template(data);
    //             activeTab.removeAttribute('data-ajax');
    //         }
    //     });
    // }

    /**
     * При создании экземпляра класса, проверяем есть ли у нас параметры в адресной строке.
     * Если есть - вытаскиваем их в массив.
     */
    // getUrlParams() {
    //     // берем строку из урла и обрезаем ему первый символ и ппреобразуем в массив
    //     const getArray = window.location.search.replace('?', '').split('&');
    //
    //     if (getArray.length) {
    //         // передаем массив для сравнения с data-tab атибутами
    //         this.comparisonTabUrl(getArray);
    //         urlArray = getArray;
    //     }
    // }

    /**
     * Если в get параметрах url'a есть значения соответствующие значениям data-tab атрибутов, то открываем этот таб
     * @param {array} getArray - массив get параметров из url'a для сравнения с значениями data-tab атрибутов
     */
    // comparisonTabUrl(getArray) {
    //     // проходим по массиву из значений взятых в урле
    //     getArray.forEach((element) => {
    //         // проходим по массиву data-tab элементов
    //         this.tabs.forEach((tab) => {
    //             // ищем совпадение значений data-tab атирубтов со значениями из урла
    //             if (tab.dataset.tab === element) {
    //                 // вызываем метод смены табов в случае совпадения
    //                 this.setData(tab);
    //                 this.changeState();
    //             }
    //         });
    //     });
    // }
}

export default Tabs;
